<div class="modal-header bg-dark text-center">
    <h4 class="modal-title">Informazioni <strong>Distinta di Pagamento</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body" style="margin-bottom: 30px;">
    {{ paymentDetails }}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.close()">Chiudi</button>
</div>
